import { Component, ViewEncapsulation } from '@angular/core';
import { FiDocumentTemplateItemOptionsBase } from '../document-template-item-options-base';

@Component({
    selector: 'fi-document-template-item-options-site-map',
    templateUrl: './document-template-item-options-site-map.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./document-template-item-options-site-map.component.scss'],
    standalone: false,
})
export class FiDocumentTemplateItemOptionsSiteMapComponent extends FiDocumentTemplateItemOptionsBase {}
